import React from "react";

const ExperienceTextSection = () => {
  return (
    <div className="overflow-hidden">
      <p className=" font-bold px-2 inline rounded-lg md:text-4xl text-3xl animate-pulse">
        Skills / Expertise
      </p>
      <p className="pt-4   text-[1.1rem] md:text-[1.4rem] font-josefin-sans pl-2">
        Technologies I've worked with
      </p>
    </div>
  );
};

export default ExperienceTextSection;
